var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40137 15C4.95365 15 5.40137 15.4477 5.40137 16V19H19.4014V16C19.4014 15.4477 19.8491 15 20.4014 15C20.9537 15 21.4014 15.4477 21.4014 16V20C21.4014 20.5523 20.9537 21 20.4014 21H4.40137C3.84908 21 3.40137 20.5523 3.40137 20V16C3.40137 15.4477 3.84908 15 4.40137 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3C13.0523 3 13.5 3.44772 13.5 4V12.7546L16.831 9.75671C17.2415 9.38725 17.8738 9.42053 18.2433 9.83104C18.6128 10.2415 18.5795 10.8738 18.169 11.2433L13.169 15.7433C12.7736 16.0991 12.169 16.0832 11.7929 15.7071L7.29289 11.2071C6.90237 10.8166 6.90237 10.1834 7.29289 9.79289C7.68342 9.40237 8.31658 9.40237 8.70711 9.79289L11.5 12.5858V4C11.5 3.44772 11.9477 3 12.5 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.0b48ceb39fd104646c8ccea2ea5f4765.svg";
export { ForwardRef as ReactComponent };